// Silhueta humana compartilhada (hero e mapa corporal). Coordenadas no eixo central x = 92;
// os caminhos "lado" descrevem o lado esquerdo do observador e são espelhados para o direito.
export const CX = 92;
export const MIRROR = `translate(${CX * 2} 0) scale(-1 1)`;

export const SYM = {
  head: 'M92 5 C101 5 107 13 107 23 C107 33 101 40 92 41 C83 40 77 33 77 23 C77 13 83 5 92 5Z',
  neck: 'M85 39 C88 43 96 43 99 39 L100 55 L84 55Z',
  headNeck: 'M92 5 C101 5 107 13 107 23 C107 30 104 36 100 39 L100 55 L84 55 L84 39 C80 36 77 30 77 23 C77 13 83 5 92 5Z',
  torso: 'M84 54 C77 54 72 55 68 59 C66 70 68 82 69 92 C70 104 73 112 73 122 C73 131 69 138 70 148 L114 148 C115 138 111 131 111 122 C111 112 114 104 115 92 C116 82 118 70 116 59 C112 55 107 54 100 54Z',
  genital: 'M87 148 L97 148 L97 158 C95 162 89 162 87 158Z'
};

export const SIDE = {
  arm: 'M68 58 C60 59 55 65 54 74 L51 100 C54 102 59 103 62 102 L68 91 C69 80 68 68 68 58Z',
  forearm: 'M51 100 C54 102 59 103 62 102 C61 114 60 124 58 134 C54 135 50 134 47 131 C48 120 49 110 51 100Z',
  hand: 'M47 131 C50 134 54 135 58 134 L56 148 C55 154 51 157 47 155 C43 152 44 140 47 131Z',
  thigh: 'M70 146 L91 150 C91 165 90 178 88 190 C82 192 72 192 67 190 C66 175 66 160 70 146Z',
  leg: 'M67 192 C72 193 82 193 88 191 C89 205 87 220 84 238 L72 238 C70 220 66 206 67 192Z',
  foot: 'M72 240 L84 240 L85 254 C86 262 84 267 78 267 L66 267 C65 262 68 258 70 252Z',
  glute: 'M71 128 L91 128 L91 152 C82 157 73 153 70 146 C69 140 70 134 71 128Z',
  upperLimb: 'M68 58 C60 59 55 65 54 74 L51 100 C49 112 48 122 47 131 C44 140 44 152 47 155 C51 157 55 154 56 148 L58 134 C60 124 61 114 62 102 L68 91 C69 80 68 68 68 58Z',
  lowerLimb: 'M70 146 L91 150 C91 165 90 178 88 190 C89 205 87 220 84 238 L85 254 C86 262 84 267 78 267 L66 267 C65 262 68 258 70 252 L72 238 C70 220 66 206 67 190 C66 175 66 160 70 146Z'
};

// Âncoras dos rótulos de % (lado esquerdo do observador; o direito é espelhado).
export const ANCHOR = {
  head: [92, 25], headNeck: [92, 25], torso: [92, 104],
  arm: [59, 80], forearm: [55, 118], thigh: [80, 170], leg: [78, 216],
  glute: [81, 142], upperLimb: [58, 104], lowerLimb: [79, 206]
};
